// extracted by mini-css-extract-plugin
export default {"rating":"kB-z","numberOfStars":"lB-z","count":"mB-z","barGraphSpacing":"nB-z","barGraph":"oB-z"};